import { useMemo } from 'react';
import { useQuery } from 'react-query';
import axiosConn from '../axiosConn';

export const getGalaxyMembersQueryKey = (galaxyId, token) => [
  'galaxyMembers',
  galaxyId,
  token,
];

export const fetchGalaxyMembers = async ({ galaxyId, token }) => {
  const response = await axiosConn.get(`galaxies/${galaxyId}/members`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return Array.isArray(response.data?.members) ? response.data.members : [];
};

export default function useGalaxyMembers({
  galaxyId,
  token,
  enabled = true,
} = {}) {
  const query = useQuery(
    getGalaxyMembersQueryKey(galaxyId, token),
    () => fetchGalaxyMembers({ galaxyId, token }),
    {
      enabled: Boolean(enabled && galaxyId && token),
    },
  );

  const members = useMemo(
    () => (Array.isArray(query.data) ? query.data : []),
    [query.data],
  );

  return {
    ...query,
    members,
    memberCount: members.length,
    isSuccess: Boolean(query.isSuccess || query.status === 'success'),
    isError: Boolean(query.isError || query.status === 'error'),
    isLoading: Boolean(query.isLoading || query.status === 'loading'),
  };
}
